<template>
    <div>
        <div class="card border-primary mb-3">
            <div class="card-body">
                <!--<h5 class="card-title">Special title treatment</h5>-->
                <!-- {{model}} -->
                <div class="row">
                    <div class="form-group col-sm-12 col-md-6">
                        <label
                            class="font-weight-bold required"
                            :for="'participationTypeName' + _uid"
                        >{{$t('participationType.gridHeaders.name')}}</label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="model.name"
                            v-validate="'required'"
                            :data-vv-as="$t('participationType.gridHeaders.name')"
                            :name="'participationTypeName' + _uid"
                            :id="'participationTypeName' + _uid"
                        />
                        <span
                            class="text-danger"
                            v-if="errors.has('participationTypeName' + _uid)"
                        >{{ errors.first('participationTypeName' + _uid) }}</span>
                    </div>

                    <div class="form-group col-sm-12 col-md-6">
                        <label
                            class="font-weight-bold"
                            :for="'participationTypeNameEn' + _uid"
                        >{{$t('participationType.gridHeaders.nameEn')}}</label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="model.nameEn"
                            :name="'participationTypeNameEn' + _uid"
                            :id="'participationTypeNameEn' + _uid"
                        />
                    </div>

                    <div class="form-group col-12">
                        <label
                            class="font-weight-bold"
                            :for="'participationTypeDescription' + _uid"
                        >{{ $t('participationType.gridHeaders.description')}}</label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="model.description"
                            :name="'participationTypeDescription' + _uid"
                            :id="'participationTypeDescription' + _uid"
                        />
                    </div>

                    <div class="form-group col-sm-12 col-md-6">
                        <label
                            class="font-weight-bold"
                            :for="'participationRelationTypes' + _uid"
                        >{{ $t('participationType.gridHeaders.participationRelationType')}}</label>
                        <DynamicMultiSelect
                            :apiUrl="'/api/participationRelationType/getDropdownModels'"
                            v-model="model.participationRelationTypes"
                            :id="'participationRelationTypes' + _uid"
                            :name="'participationRelationTypes' + _uid"
                            :required="false"
                            :filter="'contains'"
                            :height="400"
                            :fieldName="$t('participationType.gridHeaders.participationRelationType')"
                        ></DynamicMultiSelect>
                    </div>

                    <div class="form-group col-sm-12 col-md-6">
                        <label
                            class="font-weight-bold"
                            :for="'reasonForAdmissions' + _uid"
                        >{{ $t('participationType.gridHeaders.reasonForAdmission')}}</label>
                        <DynamicMultiSelect
                            :apiUrl="'/api/reasonForAdmission/getDropdownModels'"
                            v-model="model.reasonForAdmissions"
                            :id="'reasonForAdmissions' + _uid"
                            :name="'reasonForAdmissions' + _uid"
                            :required="false"
                            :filter="'contains'"
                            :height="400"
                            :fieldName="$t('participationType.gridHeaders.reasonForAdmission')"
                        ></DynamicMultiSelect>
                    </div>

                    <div class="form-group col-sm-12 col-md-6 ">
                        <label class="font-weight-bold"></label>
                        <vs-checkbox
                            v-model="model.isParticipation"
                            :name="'participationTypIsParticipation' + _uid"
                            :id="'participationTypIsParticipation' + _uid"
                            style="justify-content: flex-start !important"
                        >{{ $t('participationType.gridHeaders.isParticipation') }}</vs-checkbox>
                    </div>

                    <div class="form-group col-sm-12 col-md-6">
                        <label class="font-weight-bold"></label>
                        <vs-checkbox
                            v-model="model.isLecturerType"
                            :name="'isLecturerType' + _uid"
                            :id="'isLecturerType' + _uid"
                            style="justify-content: flex-start !important"
                        >{{ $t('participationType.gridHeaders.isLecturerType') }}</vs-checkbox>
                    </div>

                    <div class="form-group col-sm-12 col-md-6">
                        <label class="font-weight-bold"></label>
                        <vs-checkbox
                            v-model="model.isCoordinatorType"
                            :name="'isCoordinatorType' + _uid"
                            :id="'isCoordinatorType' + _uid"
                            style="justify-content: flex-start !important"
                        >{{ $t('participationType.gridHeaders.isCoordinatorType') }}</vs-checkbox>
                    </div>

                    <div class="form-group col-sm-12 col-md-6">
                        <label class="font-weight-bold"></label>
                        <vs-checkbox
                            v-model="model.deactivated"
                            :name="'participationTypeDeactivated' + _uid"
                            :id="'participationTypeDeactivated' + _uid"
                            style="justify-content: flex-start !important"
                        >{{ $t('participationType.gridHeaders.deactivated') }}</vs-checkbox>
                    </div>
                </div>
            </div>

            <div class="footer">
                <div class="text-right mt-3">
                    <div
                        class="btn-group"
                        role="group"
                        aria-label="Participation type edit buttons"
                    >
                        <button
                            v-if="hasCreateRights"
                            type="button"
                            class="btn btn-success"
                            @click.stop="onSave"
                            :disabled="saving"
                        >
                            <i v-if="saving" class="fas fa-spinner fa-spin"></i>
                            <i v-else class="fas fa-save mr-2"></i>
                            {{ $t('buttons.save.btnText')}}
                        </button>
                        <button
                            type="button"
                            class="btn btn-danger"
                            @click.stop="onCancel"
                            :disabled="saving"
                        >
                            <i class="fas fa-ban mr-2"></i>
                            {{ $t('buttons.cancel')}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ParticipationType } from "../../../models/models";
import { Culture } from "../../../models/enums";
import participationTypeService from "../../../services/participationType.service";
import DynamicMultiSelect from "../../../components/dropdown/DynamicMultiSelect";

export default {
    inject: ["$validator"],
    props: {
        value: {
            type: ParticipationType,
            required: false,
        },
        create: {
            type: Boolean,
            default: false,
        },
    },
    components: { DynamicMultiSelect },
    data() {
        return {
            model: this.value,
            saving: false,
        };
    },
    methods: {
        onCancel() {
            this.$emit("cancel");
        },
        onSave() {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.doSave();
                }
            });
        },
        doSave() {
            if (this.create && this.isNew) {
                this.createParticipationType();
            } else {
                this.updateParticipationType();
            }
        },
        createParticipationType() {
            const msg = `${this.$t("participationType.create")}`;
            this.saving = true;

            participationTypeService
                .create(this.model)
                .then((response) => {
                    this.$vs.notify({
                        title: msg,
                        text: this.$helpers.responseMessage(response),
                        color: "success",
                        time: this.$store.getters.notificationDuration,
                    });

                    this.$emit("save", this.model);
                })
                .catch((error) => {
                    this.$vs.notify({
                        title: msg,
                        text: this.$helpers.errorText(error),
                        color: this.$helpers.errorColor(error),
                        time: this.$store.getters.notificationDuration,
                    });
                })
                .then(() => {
                    this.saving = false;
                });
        },
        updateParticipationType() {
            const msg = `${this.$t("participationType.edit")}`;
            this.saving = true;

            participationTypeService
                .update(this.model)
                .then((response) => {
                    this.$vs.notify({
                        title: msg,
                        text: this.$helpers.responseMessage(response),
                        color: "success",
                        time: this.$store.getters.notificationDuration,
                    });

                    this.$emit("save", this.model);
                })
                .catch((error) => {
                    this.$vs.notify({
                        title: msg,
                        text: this.$helpers.errorText(error),
                        color: this.$helpers.errorColor(error),
                        time: this.$store.getters.notificationDuration,
                    });
                })
                .then(() => {
                    this.saving = false;
                });
        },
    },
    computed: {
        token: function () {
            return this.$store.getters.authToken;
        },
        isEnVersion() {
            return this.$store.getters.currentCulture === Culture.EN;
        },
        isNew() {
            let id = Number(this.model.id);
            return isNaN(id) || id <= 0;
        },
        hasCreateRights() {
            return this.$store.getters.claims.nomenclatureTypes.create;
        },
    },
    mounted() {},
    watch: {
        value: function (val) {
            if (val) {
                this.model = new ParticipationType(this.value);
            }
        },
    },
};
</script>

<style scoped>
input[readonly] {
    background-color: whitesmoke;
}

textarea[readonly] {
    background-color: whitesmoke;
}
</style>
